import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const handler = () => setVisible(window.scrollY > 600);
        window.addEventListener("scroll", handler, { passive: true });
        handler();
        return () => window.removeEventListener("scroll", handler);
    }, []);

    if (!visible) return null;
    return (
        <button
            type="button"
            data-testid="back-to-top"
            aria-label="Back to top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-6 left-6 z-40 w-11 h-11 rounded-full bg-deep-blue hover:bg-dark-navy text-white shadow-lg flex items-center justify-center"
        >
            <ArrowUp className="w-5 h-5" />
        </button>
    );
}
